import { Masonry } from "@mui/lab";
import { Box, Rating, Skeleton } from "@mui/material";
import React from "react";

const CardLoader = () => {
  return (
    <>
      <Masonry
        defaultColumns={{ lg: 6, sm: 4, xs: 2 }}
        defaultHeight={450}
        columns={{ lg: 6, md: 6, sm: 4, xs: 2 }}
        spacing={2}
        sx={{ mt: 2, width: "100%", mx: 0 }}
      >
        <Skeletons height={130} />

        <Skeletons height={100} />

        <Skeletons height={180} />

        <Skeletons height={70} />

        <Skeletons height={100} />

        <Skeletons height={200} />
      </Masonry>
    </>
  );
};

export default CardLoader;

const Skeletons = ({ height }) => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "8px",
        cursor: "pointer",
        overflow: "hidden",
        boxSizing: "border-box",
        transition: "0.2s all linear",
        p: 0,

        width: "100%",

        "&:hover": {
          boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
        },
      }}
    >
      <Box>
        <Skeleton animation="wave" variant="rectangle" height={height} />

        {/* </Box> */}

        <Box sx={{ pb: 1, p: 1 }}>
          <Skeleton
            variant="rectangle"
            animation="wave"
            height={10}
            sx={{ width: "60%" }}
          />
          <Skeleton
            variant="rectangle"
            height={25}
            animation="wave"
            sx={{ mt: 0.5 }}
          />
          <Skeleton
            variant="rectangle"
            height={10}
            animation="wave"
            sx={{ mt: 0.5, width: "30%" }}
          />

          {/* <CurrencyDisplay amount={price.toLocaleString()}/> */}
          <Rating
            readOnly
            size="small"
            sx={{ fontSize: "12px", color: "#df7922" }}
            precision={0.5}
          />
        </Box>
      </Box>
    </Box>
  );
};
